// dvla-external-frontend bundle
import { initializeApplication } from './index';

initializeApplication();
